import { MapPinIcon } from "@heroicons/react/24/outline";
import { FACILITY } from "../../../../constants";

export default function FacilityAddress() {
  return (
    <div className="bg-white rounded-xl md:px-10 px-4 py-7 shadow-sm border border-slate-100 flex flex-col items-center">
      <h2 className="md:text-2xl text-lg font-medium text-slate-800 mb-6 text-center">
        Send your item to our facility at:
      </h2>
      <div className="w-full bg-blue-50 border border-[#D1E4FF] rounded-xl md:px-5 md:py-4 px-4 py-3 flex items-center gap-4">
        <MapPinIcon className="w-6 h-6 text-[#3366CC] shrink-0" />
        <div className="flex flex-col gap-0.5 w-full">
          <p className="text-[#3366CC] md:text-lg text-sm font-medium leading-relaxed">
            {FACILITY.name}
          </p>
          <p className="text-[#3366CC] md:text-lg text-sm leading-relaxed">
            {FACILITY.address}
          </p>
        </div>
      </div>
    </div>
  );
}
